export const placeholderRegex = /\$\{(\w+)(\.\w+)*\}/g;

/**
 * Extracts all the placeholders that are contained within a string, placeholders
 * are enclosed with the dollar sign and curly braces, i.e. ${placeholder}
 * @param {string} message - A message string containing the placeholders
 * @returns {string[]} - An array with all the placeholder contained within the message
 */
export const extractAllPlaceholdersFromString = (message) => {
    if (typeof message !== "string") return [];
    return message.match(placeholderRegex) ?? [];
};
